module.exports = __webpack_public_path__ + "img/role-management.88d2ed8a.png";